import { ReactComponent as Icon } from '../../assets/icons/contractDetailIcon.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" />;
}
